import { produce } from 'immer';
import {
  BROWSER_LANGUAGE_CHANGED,
  PUBLIC_PAGE_PREFERRED_LANGUAGE_SELECTED
} from "redux/localization/actions";

export const initialState = {
  publicPagePreferredLanguage: null,
  browserLanguage: null,
}

const localization = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case PUBLIC_PAGE_PREFERRED_LANGUAGE_SELECTED:
      draft.publicPagePreferredLanguage = action.payload
      break
    case BROWSER_LANGUAGE_CHANGED:
      draft.browserLanguage = action.payload
      break
    default:
      break
  }
})
export default localization
